import React, { useState } from "react";
import PlaywrightTemplate from "./PlaywrightTemplate";
import styles from "../../styles/Playwrightpages.module.css";

const PwForm = () => {

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    gender: "",
    skills: [],
    country: ""
  });

  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (type === "checkbox") {
      let updatedSkills = [...formData.skills];
      if (checked) {
        updatedSkills.push(value);
      } else {
        updatedSkills = updatedSkills.filter(skill => skill !== value);
      }
      setFormData({ ...formData, skills: updatedSkills });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
  };

  const sections = [
    {
      heading: "USER REGISTRATION FORM",
      ui: (
        <form className={styles.form} onSubmit={handleSubmit}>

          <input
            name="name"
            placeholder="Enter Name"
            value={formData.name}
            onChange={handleChange}
            className={styles.input}
          />

          <input
            name="email"
            type="email"
            placeholder="Enter Email"
            value={formData.email}
            onChange={handleChange}
            className={styles.input}
          />

          <input
            name="password"
            type="password"
            placeholder="Enter Password"
            value={formData.password}
            onChange={handleChange}
            className={styles.input}
          />

          {/* Gender */}
          <div>
            <label>
              <input
                type="radio"
                name="gender"
                value="Male"
                onChange={handleChange}
              /> Male
            </label>

            <label>
              <input
                type="radio"
                name="gender"
                value="Female"
                onChange={handleChange}
              /> Female
            </label>
          </div>

          {/* Skills */}
          <div>
            <label htmlFor="selenium">
              <input
                type="checkbox"
                id="selenium"
                value="Selenium"
                onChange={handleChange}
              /> Selenium
            </label>

            <label htmlFor="playwright">
              <input
                type="checkbox"
                id="playwright"
                value="Playwright"
                onChange={handleChange}
              /> Playwright
            </label>
          </div>

          {/* Country */}
          <select
            name="country"
            onChange={handleChange}
            className={styles.input}
          >
            <option value="">Select Country</option>
            <option value="India">India</option>
            <option value="USA">USA</option>
          </select>

          <button type="submit" className={styles.primaryBtn}>
            Submit
          </button>

          {submitted && (
            <p id="success-message" className={styles.successText}>
              Form Submitted Successfully
            </p>
          )}

        </form>
      ),

      code: `// Fill form
await page.getByPlaceholder('Enter Name').fill('Logesh');
await page.getByPlaceholder('Enter Email').fill('logesh@test.com');
await page.getByPlaceholder('Enter Password').fill('123456');

// Select radio
await page.getByLabel('Male').check();

// Select checkbox
await page.getByLabel('Playwright').check();

// Select dropdown
await page.selectOption('select[name="country"]', 'India');

// Submit
await page.getByRole('button', { name: 'Submit' }).click();

// Assert success
await expect(page.locator('#success-message')).toBeVisible();`
    }
  ];

  return <PlaywrightTemplate title="FORM HANDLING" sections={sections} />;
};

export default PwForm;